import {SET_FAMILY_FRIENDLY} from '../actions/action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_FAMILY_FRIENDLY:

            const filters = state.filters || action.payload.filters;
            const listings = state.listings || {};
            listings[action.payload.refinementKey] = action.payload.listings;

            return {
                ...state,
                ...action.payload,
                filters,
                listings
            };

        default:
            return state;
    }
};
